"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var iconSet = {
  "default": 'M 21.99845,12 A 9.9984505,10.000028 0 0 0 2.0015496,12 9.9984505,10.000028 0 0 0 21.99845,12 Z M 5.7588632,5.7578784 A 8.7896413,8.7910277 0 0 1 11.43301,3.1939989 9.8314407,9.8329917 0 0 1 8.5891021,9.2117405 9.8900961,9.8916564 0 0 1 3.1770063,11.978317 8.7983062,8.799694 0 0 1 5.7588632,5.7578784 Z M 3.2538304,13.151602 A 11.064537,11.066282 0 0 0 9.4190856,10.039969 10.997883,10.999618 0 0 0 12.60988,3.1972986 8.8096374,8.8110271 0 0 1 20.802256,11.375883 11.041208,11.042949 0 0 0 10.836798,20.745194 8.8069712,8.8083603 0 0 1 3.2543017,13.150188 Z m 8.7546526,7.671842 a 9.8700999,9.871657 0 0 1 8.794716,-8.268148 8.8103039,8.8116937 0 0 1 -8.794716,8.268148 z'
};
var _default = iconSet;
exports["default"] = _default;